import { render, staticRenderFns } from "./approvalCenter.vue?vue&type=template&id=15432f01"
import script from "./approvalCenter.vue?vue&type=script&lang=js"
export * from "./approvalCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports